import { dynamicLoader } from '~/utils';

export const EstimateScopeEditor = dynamicLoader({
  name: 'EstimateScopeEditorWrapper',
  importFunc: () => import('./estimate-scope-editor-wrapper'),
});